import { connect } from 'react-redux';

import { HelpModalContent } from './HelpModalContent';
import { isIwocaPayCustomer as isIwocaPayCustomerSelector } from '../../../api/iwocaPaySelector';
import { CLOSE_MODAL } from '../../../iwModals/Modals.actions';

const mapStateToProps = (state) => ({
    hasIwocaPayLoan: isIwocaPayCustomerSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => {
        dispatch({
            type: CLOSE_MODAL
        });
    }
});
// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(({ closeModal, hasIwocaPayLoan }) => {
    return (
        <HelpModalContent
            isIwocaPayLoan={hasIwocaPayLoan}
            onChatButtonClick={closeModal}
        />
    );
});
